import { useCreation } from 'ahooks';
import { Divider, Space } from 'antd';
import PlatformTag from 'components/PlatformTag';
import React, { memo } from 'react';
import { useTranslate } from '@tolgee/react';
import groupByTs from 'utils/groupByTs';
import { useDepartmentDetailOfId } from './hooks/data';

interface Department extends StoreHomeV2.Department {}

export interface DepartmentStoreScopeStatsProps {
  departmentId?: Department['id'];
}

const DepartmentStoreScopeStats = (props: DepartmentStoreScopeStatsProps) => {
  const { departmentId } = props;
  const { t } = useTranslate();
  const { data } = useDepartmentDetailOfId(departmentId);

  return useCreation(() => {
    const platformStats = groupByTs(data?.platformStoreScopes || [], 'platform');
    const sum = (scopes: General.StoreScope[] = []) => {
      return scopes.reduce((sum, t) => sum + (t.storeCount || 0), 0);
    };
    const sums = {
      SHOPEE: sum(platformStats.SHOPEE),
      LAZADA: sum(platformStats.LAZADA),
      TOKOPEDIA: sum(platformStats.TOKOPEDIA),
      WA_BIZ: sum(platformStats.WA_BIZ),
      TIKTOK: sum(platformStats.TIKTOK),
      TIKTOK_US: sum(platformStats.TIKTOK_US),
      MERCADO: sum(platformStats.MERCADO),
      KWAI: sum(platformStats.KWAI),
      FACEBOOK: sum(platformStats.FACEBOOK),
    };
    return (
      <div className="flex">
        <div>{t('department.负责店铺')}：</div>
        <div className="flex-1">
          <Space size={1} wrap>
            {Object.keys(sums).reduce((nodes, platform) => {
              const count = sums[platform];
              if (!count) {
                return nodes;
              }
              const noDivider = nodes.length < 1;
              nodes.push(
                <div key={`DepartmentStoreScopeStats_${platform}`} className="mb-1">
                  {noDivider ? null : <Divider type="vertical" />}
                  <PlatformTag platform={platform} />
                  {t('feedback.全部')}({count})
                </div>,
              );
              return nodes;
            }, [] as React.ReactNode[])}
          </Space>
        </div>
      </div>
    );
  }, [data, t]);
};
export default memo(DepartmentStoreScopeStats);
